import {Platform} from 'react-native';

import {isSiteHeaderActive} from '../../components/SiteHeader/headerDenyList';
// Icons (SVG)
// Drawer
import config from '../../config';
import MyStoreSvg from '../../images/brand/icons/side-menu/my-store.svg';
import PromotionsSvg from '../../images/brand/icons/side-menu/promotions.svg';
import ResponsibleServiceSvg from '../../images/brand/icons/side-menu/responsible-service.svg';
import SelfExclusionSvg from '../../images/brand/icons/side-menu/self-exclusion.svg';
import WishListSvg from '../../images/brand/icons/side-menu/wishlist.svg';
// Bottom tabs
import CartIcon from '../../images/brand/svg/tabButtons/Cart.svg';
import CatalogueIcon from '../../images/brand/svg/tabButtons/Catalogue.svg';
import DiscoverIcon from '../../images/brand/svg/tabButtons/Discover.svg';
import RewardsIcon from '../../images/brand/svg/tabButtons/Rewards.svg';
import RewardsFocusedIcon from '../../images/brand/svg/tabButtons/RewardsFocused.svg';
import ShopIcon from '../../images/brand/svg/tabButtons/Shop.svg';
import TodayIcon from '../../images/brand/svg/tabButtons/Today.svg';
import {AppRoute} from '../../models/AppRoute';
import BrandDetailScreen from '../../screens/articles/BrandDetailScreen';
import DiscoverListScreen from '../../screens/articles/DiscoverListScreen';
import ExclusiveOfferDetailScreen from '../../screens/articles/ExclusiveOfferDetailScreen';
import FavouriteBrandsScreen from '../../screens/articles/FavouriteBrandsScreen';
import FeedDiscoverDetailScreen from '../../screens/articles/FeedDiscoverDetailScreen';
import PromotionDetailScreen from '../../screens/articles/PromotionDetailScreen';
import PromotionIFrameLinkScreen from '../../screens/articles/PromotionIFrameLinkScreen';
import PromotionsDrawnWinnersListScreen from '../../screens/articles/PromotionsDrawnWinnersListScreen';
import PromotionsListScreen from '../../screens/articles/PromotionsListScreen';
import RewardsListScreen from '../../screens/articles/RewardsListScreen';
import CartScreen from '../../screens/cart/CartScreen';
import CheckoutScreen from '../../screens/cart/CheckoutScreen';
import CatalogueScreen from '../../screens/catalogue/CatalogueScreen';
import {
  BRAND_NAME,
  DEPARTMENT_NAME,
  DISCOVER_FILTER,
  DISCOVER_SEGMENT,
  EXCLUSIVE_OFFER_LIST,
  EXCLUSIVE_OFFER_NAME,
  FAVOURITE_BRANDS,
  FILTER_MFL,
  FILTER_SEGMENT,
  MEMBERS_PRICE_LIST,
  ORDER_CONFIRMATION,
  PROCESSING_ORDER,
  PROMOTION_NAME,
  PROMOTIONS_CURRENT,
  PROMOTIONS_MAIN,
  PROMOTIONS_WINNERS,
  RESPONSIBLE_SERVICE,
  RESPONSIBLE_SERVICE_LIQUOR_LICENSING_LAWS,
  RESPONSIBLE_SERVICE_THIRD_PARTY_REQUEST,
  SEARCH,
  SELF_EXCLUSION,
  SHOP_ALL_NAME,
  STORE_NAME,
  STORE_NAME_CARD,
  SUB_DEPARTMENT_NAME,
  VIEW_ORDER,
} from '../../screens/constants';
import DeveloperSettingsScreen from '../../screens/developer/DeveloperSettingsScreen';
import ExclusiveOfferListScreen from '../../screens/ExclusiveOfferListScreen';
import GiftCardsPromotionWaiter from '../../screens/giftCards/GiftCardsPromotionWaiter';
import HomepageScreen from '../../screens/HomepageScreen';
import MembersPriceListScreen from '../../screens/MembersPriceListScreen';
import OrderCompetitionScreen from '../../screens/OrderCompetitionScreen';
import OrderConfirmationScreen from '../../screens/OrderConfirmationScreen';
import PromotionsScreen from '../../screens/promotions/PromotionsScreen';
import ResponsibleServiceThirdPartyRequestScreen from '../../screens/responsibleService/HelpContactThirdPartyRequestScreen';
import LiquorLicensingLawsScreen from '../../screens/responsibleService/LiquorLicensingLawsScreen';
import ResponsibleServiceScreen from '../../screens/responsibleService/ResponsibleServiceScreen';
import SearchScreen from '../../screens/search';
import SelfExclusionScreen from '../../screens/selfExclusion/SelfExclusionScreen';
import DepartmentScreen from '../../screens/shop/DepartmentScreen';
import JoinedDepartmentsScreen from '../../screens/shop/JoinedDepartmentsScreen';
import RangeProductDetailScreen from '../../screens/shop/RangeProductDetailScreen';
import ShopScreen from '../../screens/shop/ShopScreen';
import SubDepartmentScreen from '../../screens/shop/SubDepartmentScreen';
import StoreDetailScreen from '../../screens/StoreDetailScreen';
import StoreSwitchLinkScreen from '../../screens/StoreSwitchLinkScreen';
import StorybookScreen from '../../screens/StorybookScreen';
import WishlistScreen from '../../screens/WishlistScreen';
import {brandRewardsCopy} from '../../utils/rewards';
import {drawerIcon} from '../components/DrawerIcon';
import {header} from '../components/Header';
import {rewardsTabBarIcon, tabBarIcon} from '../components/TabBarIcon';

import {
  commonDrawerRouteProps,
  commonNoTabOrDrawerRouteProps,
  commonTabRouteProps,
} from './commonRouteProps';
import {RouteSpec, RouteWithoutTargetStoreType, TargetStoreType} from './types';

const findRouteIndex = (routes: RouteWithoutTargetStoreType[], routeName: AppRoute) => {
  return routes.findIndex(r => r.name === routeName);
};

const addOrUpdateRoute = (
  routes: RouteWithoutTargetStoreType[],
  route: RouteWithoutTargetStoreType,
) => {
  const index = findRouteIndex(routes, route.name);
  if (index === -1) {
    routes.push(route);
    return true;
  } else {
    routes[index] = route;
    return false;
  }
};

const replaceRoute = (
  routes: RouteWithoutTargetStoreType[],
  targetRouteName: AppRoute,
  route: RouteWithoutTargetStoreType,
) => {
  const index = findRouteIndex(routes, targetRouteName);
  if (index !== -1) {
    routes[index] = route;
  } else {
    throw new Error(`Unable to replace route: No route found for ${targetRouteName}`);
  }
};

const removeRoute = (routes: RouteWithoutTargetStoreType[], targetRouteName: AppRoute) => {
  const index = findRouteIndex(routes, targetRouteName);
  if (index !== -1) {
    routes.splice(index, 1);
  }
};

// Routes only reachable through navigation from tab or drawer screens
// (no on tab or drawer themselves)
const noTabOrDrawerRoutes: RouteWithoutTargetStoreType[] = [
  {
    name: AppRoute.ARTICLE,
    component: FeedDiscoverDetailScreen,
    header: header({
      back: true,
      filter: false,
      burger: true,
      search: true,
      source: DISCOVER_SEGMENT,
    }),
    ...commonNoTabOrDrawerRouteProps,
  },
  {
    name: AppRoute.PROMOTION,
    component: PromotionDetailScreen,
    header: header({
      back: true,
      filter: false,
      burger: true,
      search: true,
      source: PROMOTION_NAME,
    }),
    ...commonNoTabOrDrawerRouteProps,
  },
  {
    name: AppRoute.PRODUCT,
    component: RangeProductDetailScreen,
    // DIS-1902: SiteHeader compacts on the product page. The old header stays static, as before.
    header: header(
      {
        back: true,
        filter: false,
        burger: true,
        search: true,
        source: STORE_NAME,
      },
      {scrollCollapse: isSiteHeaderActive()},
    ),
    headerTransparent: isSiteHeaderActive(),
    ...commonNoTabOrDrawerRouteProps,
  },
  {
    name: AppRoute.DEPARTMENT,
    component: DepartmentScreen,
    header: header(
      {
        back: true,
        filter: FILTER_MFL,
        burger: true,
        search: true,
        source: DEPARTMENT_NAME,
      },
      {scrollCollapse: true},
    ),
    headerTransparent: true,
    ...commonNoTabOrDrawerRouteProps,
  },
  {
    name: AppRoute.SHOP_ALL,
    component: JoinedDepartmentsScreen,
    header: header(
      {
        back: true,
        filter: false,
        burger: true,
        search: true,
        source: SHOP_ALL_NAME,
      },
      {scrollCollapse: true},
    ),
    headerTransparent: true,
    ...commonNoTabOrDrawerRouteProps,
  },
  {
    name: AppRoute.SUB_DEPARTMENT,
    component: SubDepartmentScreen,
    header: header(
      {
        back: true,
        filter: FILTER_MFL,
        burger: true,
        search: true,
        source: SUB_DEPARTMENT_NAME,
      },
      {scrollCollapse: true},
    ),
    headerTransparent: true,
    ...commonNoTabOrDrawerRouteProps,
  },
  {
    name: AppRoute.FAVOURITE_BRANDS,
    component: FavouriteBrandsScreen,
    header: header({
      back: true,
      shop: false,
      filter: false,
      burger: true,
      search: true,
      source: FAVOURITE_BRANDS,
    }),
    ...commonNoTabOrDrawerRouteProps,
  },
  {
    name: AppRoute.BRAND,
    component: BrandDetailScreen,
    header: header({
      back: true,
      shop: false,
      filter: false,
      burger: true,
      search: true,
      source: BRAND_NAME,
    }),
    ...commonNoTabOrDrawerRouteProps,
  },
  {
    name: AppRoute.PROMOTION_IFRAME,
    component: PromotionIFrameLinkScreen,
    header: header({
      back: true,
      filter: false,
      burger: true,
      search: true,
      source: PROMOTION_NAME,
    }),
    ...commonNoTabOrDrawerRouteProps,
  },
  {
    name: AppRoute.CART_ORDER_CHECKOUT,
    component: CheckoutScreen,
    // https://github.com/react-native-webview/react-native-webview/issues/1915#issuecomment-800871646
    // React Navigation v7: use animation: 'none' instead of animationEnabled: false
    animation: 'none',
    header: header({
      back: true,
      filter: false,
      burger: true,
      search: true,
      source: STORE_NAME,
    }),
    ...commonNoTabOrDrawerRouteProps,
  },
  {
    name: AppRoute.CART_ORDER_COMPETITIONS,
    component: OrderCompetitionScreen,
    header: header({
      back: false,
      filter: false,
      burger: true,
      search: false,
      source: PROCESSING_ORDER,
    }),
    ...commonNoTabOrDrawerRouteProps,
  },
  {
    name: AppRoute.CART_ORDER_CONFIRMATION,
    component: OrderConfirmationScreen,
    header: header({
      back: false,
      filter: false,
      burger: true,
      search: false,
      source: ORDER_CONFIRMATION,
    }),
    ...commonNoTabOrDrawerRouteProps,
  },
  {
    name: AppRoute.PROMOTIONS_CURRENT,
    component: PromotionsListScreen,
    header: header(
      {
        back: true,
        filter: false,
        burger: true,
        search: true,
        source: PROMOTIONS_CURRENT,
      },
      {scrollCollapse: true},
    ),
    headerTransparent: true,
    ...commonNoTabOrDrawerRouteProps,
  },
  {
    name: AppRoute.PROMOTIONS_WINNERS,
    component: PromotionsDrawnWinnersListScreen,
    header: header(
      {
        back: true,
        filter: false,
        burger: true,
        search: true,
        source: PROMOTIONS_WINNERS,
      },
      {scrollCollapse: true},
    ),
    headerTransparent: true,
    ...commonNoTabOrDrawerRouteProps,
  },
  {
    name: AppRoute.RESPONSIBLE_SERVICE_LIQUOR_LICENSING_LAWS,
    component: LiquorLicensingLawsScreen,
    header: header({
      back: true,
      shop: false,
      filter: false,
      burger: true,
      search: true,
      source: RESPONSIBLE_SERVICE_LIQUOR_LICENSING_LAWS,
    }),
    ...commonNoTabOrDrawerRouteProps,
  },
  {
    name: AppRoute.RESPONSIBLE_SERVICE_THIRD_PARTY_REQUEST,
    component: ResponsibleServiceThirdPartyRequestScreen,
    header: header({
      back: true,
      shop: false,
      filter: false,
      burger: true,
      search: true,
      source: RESPONSIBLE_SERVICE_THIRD_PARTY_REQUEST,
    }),
    ...commonNoTabOrDrawerRouteProps,
  },
  {
    name: AppRoute.NEW_SEARCH,
    component: SearchScreen,
    header: header({
      back: true,
      shop: false,
      filter: false,
      burger: true,
      search: false,
      source: SEARCH,
    }),
    ...commonNoTabOrDrawerRouteProps,
  },
  {
    name: AppRoute.STORE_SWITCH_LINK,
    component: StoreSwitchLinkScreen,
    header: header({
      back: false,
      shop: true,
      filter: false,
      burger: true,
      search: true,
      source: STORE_NAME,
    }),
    ...commonNoTabOrDrawerRouteProps,
  },
  {
    name: AppRoute.GIFT_CARDS_PROMOTION_WAITER,
    component: GiftCardsPromotionWaiter,
    header: header({
      back: true,
      shop: false,
      filter: false,
      burger: true,
      search: true,
      source: VIEW_ORDER,
    }),
    ...commonNoTabOrDrawerRouteProps,
  },
  // {
  //   name: AppRoute.SUMMER_CASH_GRAB_GAME,
  //   component: SummerCashGrabScreen,
  //   header: header({
  //     back: true,
  //     shop: true,
  //     filter: false,
  //     burger: true,
  //     search: false,
  //     source: STORE_NAME,
  //   }),
  //   screenOptions: {
  //     presentation: 'modal',
  //   },
  //   ...commonNoTabOrDrawerRouteProps,
  // },
];

noTabOrDrawerRoutes.push({
  name: AppRoute.EXCLUSIVE_OFFER_DETAIL,
  component: ExclusiveOfferDetailScreen,
  header: header({
    back: true,
    filter: false,
    burger: true,
    search: true,
    source: EXCLUSIVE_OFFER_NAME,
  }),
  ...commonNoTabOrDrawerRouteProps,
});

noTabOrDrawerRoutes.push({
  name: AppRoute.MEMBERS_PRICE_LIST,
  component: MembersPriceListScreen,
  header: header({
    back: true,
    filter: false,
    burger: true,
    search: true,
    source: MEMBERS_PRICE_LIST,
  }),
  ...commonNoTabOrDrawerRouteProps,
});

noTabOrDrawerRoutes.push({
  name: AppRoute.EXCLUSIVE_OFFER_LIST,
  component: ExclusiveOfferListScreen,
  header: header({
    back: true,
    filter: false,
    burger: true,
    search: true,
    source: EXCLUSIVE_OFFER_LIST,
  }),
  ...commonNoTabOrDrawerRouteProps,
});

const tabRoutes = (
  ecommerceDisabled: boolean,
  _isLoggedIn: boolean,
  storeLoyaltyEnabled: boolean,
) => {
  let routes: RouteWithoutTargetStoreType[] = [
    {
      name: AppRoute.HOME,
      component: HomepageScreen,
      title: 'HOME',
      icon: tabBarIcon(TodayIcon),
      header: header(
        {
          back: true,
          shop: true,
          filter: false,
          burger: true,
          search: true,
          source: STORE_NAME_CARD,
        },
        {scrollCollapse: true},
      ),
      headerTransparent: true,
      ...commonTabRouteProps,
    },
    {
      name: AppRoute.SHOP,
      component: ShopScreen,
      title: 'SHOP',
      icon: tabBarIcon(ShopIcon),
      header: header(
        {
          back: true,
          shop: true,
          filter: false,
          burger: true,
          search: true,
          source: STORE_NAME,
        },
        {scrollCollapse: true},
      ),
      headerTransparent: true,
      ...commonTabRouteProps,
    },
    {
      name: AppRoute.DISCOVER,
      component: DiscoverListScreen,
      title: 'DISCOVER',
      icon: tabBarIcon(DiscoverIcon),
      header: header(
        {
          back: true,
          shop: false,
          filter: FILTER_SEGMENT,
          burger: true,
          search: true,
          source: DISCOVER_FILTER,
        },
        {scrollCollapse: true},
      ),
      headerTransparent: true,
      ...commonTabRouteProps,
    },
    {
      name: AppRoute.CATALOGUE,
      component: CatalogueScreen,
      title: 'CATALOGUE',
      icon: tabBarIcon(CatalogueIcon),
      header: header({
        back: true,
        shop: true,
        filter: false,
        burger: true,
        search: true,
        source: STORE_NAME,
      }),
      ...commonTabRouteProps,
    },
    {
      name: AppRoute.CART,
      component: CartScreen,
      title: 'CART',
      icon: tabBarIcon(CartIcon, true, 'cart-icon'),
      header: header(
        {
          back: true,
          shop: true,
          filter: false,
          burger: true,
          search: true,
          source: STORE_NAME_CARD,
        },
        {scrollCollapse: true},
      ),
      headerTransparent: true,
      ...commonTabRouteProps,
    },
  ];

  /**
   * Add functionality so that non ecommerce stores show different
   * bottom tabs
   */
  const tabDiscoverRouteIndex = findRouteIndex(routes, AppRoute.DISCOVER);
  if (tabDiscoverRouteIndex < 0) {
    throw new Error(
      'DEV DEBUG: No DISCOVER route in Tab Routes. Are you sure this is the right NAV state?',
    );
  }
  if (storeLoyaltyEnabled) {
    const rewardsTabRoute: RouteWithoutTargetStoreType = {
      name: AppRoute.REWARDS,
      component: RewardsListScreen,
      title: brandRewardsCopy.menuTitle.toUpperCase(),
      icon: rewardsTabBarIcon(RewardsIcon, RewardsFocusedIcon),
      tabBarLabel: () => null,
      header: header(
        {
          back: true,
          shop: false,
          filter: false,
          burger: true,
          search: true,
          source: STORE_NAME,
        },
        {scrollCollapse: true},
      ),
      headerTransparent: true,
      ...commonTabRouteProps,
    };

    if (ecommerceDisabled) {
      // Non-ecom + loyalty: keep DISCOVER tab and add REWARDS alongside it
      // (HOME | DISCOVER | REWARDS | CATALOGUE after SHOP/CART are filtered below).
      const catalogueIndex = findRouteIndex(routes, AppRoute.CATALOGUE);
      routes.splice(catalogueIndex, 0, rewardsTabRoute);
      removeRoute(noTabOrDrawerRoutes, AppRoute.DISCOVER);
      removeRoute(noTabOrDrawerRoutes, AppRoute.REWARDS);
    } else {
      // Ecom + loyalty: REWARDS replaces DISCOVER in the 5-tab bar.
      // Expose DISCOVER as a non-tab route so deep-links + nav still work.
      replaceRoute(routes, AppRoute.DISCOVER, rewardsTabRoute);

      addOrUpdateRoute(noTabOrDrawerRoutes, {
        name: AppRoute.DISCOVER,
        component: DiscoverListScreen,
        header: header(
          {
            back: true,
            shop: false,
            filter: FILTER_SEGMENT,
            burger: true,
            search: true,
            source: DISCOVER_FILTER,
          },
          {scrollCollapse: true},
        ),
        headerTransparent: true,
        ...commonNoTabOrDrawerRouteProps,
      });

      removeRoute(noTabOrDrawerRoutes, AppRoute.REWARDS);
    }
  } else {
    // When Store Loyalty is disabled
    // Add Rewards route to noTabOrDrawerRoutes
    addOrUpdateRoute(noTabOrDrawerRoutes, {
      name: AppRoute.REWARDS,
      component: RewardsListScreen,
      header: header(
        {
          back: true,
          shop: false,
          filter: false,
          burger: true,
          search: true,
          source: STORE_NAME,
        },
        {scrollCollapse: true},
      ),
      headerTransparent: true,
      ...commonNoTabOrDrawerRouteProps,
    });

    removeRoute(routes, AppRoute.REWARDS);
    removeRoute(noTabOrDrawerRoutes, AppRoute.DISCOVER);
  }

  // Non-ecommerce (darksite) stores drop commerce tabs. HOME stays on
  // HomepageScreen — product-tile sections gate themselves on
  // shopSelectionStore.ecommerceDisabled. DISCOVER / REWARDS / CATALOGUE remain.
  if (ecommerceDisabled) {
    routes = routes.filter(r => r.name !== AppRoute.SHOP && r.name !== AppRoute.CART);
  }

  return routes;
};

const drawerRoutes: RouteWithoutTargetStoreType[] = [
  {
    name: AppRoute.MY_STORE,
    component: StoreDetailScreen,
    title: 'My Store',
    icon: drawerIcon(MyStoreSvg),
    header: header({
      back: true,
      shop: true,
      filter: false,
      burger: true,
      search: true,
      source: STORE_NAME,
    }),
    drawerSortOrder: 1,
    ...commonDrawerRouteProps,
  },
  {
    name: AppRoute.WISHLIST,
    component: WishlistScreen,
    title: 'Wish list',
    icon: drawerIcon(WishListSvg),
    header: header(
      {
        back: true,
        shop: true,
        filter: false,
        burger: true,
        search: true,
        source: STORE_NAME,
      },
      {scrollCollapse: true},
    ),
    headerTransparent: true,
    drawerSortOrder: 3,
    ...commonDrawerRouteProps,
  },
  {
    name: AppRoute.PROMOTIONS,
    component: PromotionsScreen,
    title: 'Promotions',
    icon: drawerIcon(PromotionsSvg),
    header: header({
      back: true,
      shop: false,
      filter: false,
      burger: true,
      search: true,
      source: PROMOTIONS_MAIN,
    }),
    drawerSortOrder: 4,
    ...commonDrawerRouteProps,
  },

  {
    name: AppRoute.RESPONSIBLE_SERVICE,
    component: ResponsibleServiceScreen,
    title: 'Responsible Service',
    icon: drawerIcon(ResponsibleServiceSvg),
    header: header({
      back: true,
      shop: true,
      filter: false,
      burger: true,
      search: true,
      source: RESPONSIBLE_SERVICE,
    }),
    drawerSortOrder: 8,
    ...commonDrawerRouteProps,
  },
  {
    name: AppRoute.SELF_EXCLUSION,
    component: SelfExclusionScreen,
    title: 'Self Exclusion',
    icon: drawerIcon(SelfExclusionSvg),
    header: header({
      back: true,
      shop: true,
      filter: false,
      burger: true,
      search: true,
      source: SELF_EXCLUSION,
    }),
    drawerSortOrder: 9,
    ...commonDrawerRouteProps,
  },
];

if (config.STORYBOOK_ENABLED) {
  // Web only: the drawer is the sole way into the in-app web Storybook. Native opens
  // Storybook from the dev menu (App.tsx), because the drawer exists only on ecom stores.
  if (Platform.OS === 'web') {
    drawerRoutes.push({
      name: AppRoute.STORYBOOK,
      component: StorybookScreen,
      title: 'Storybook',
      header: header({
        back: true,
        filter: false,
        burger: true,
        search: false,
      }),
      drawerSortOrder: 999,
      ...commonDrawerRouteProps,
    });
  }

  drawerRoutes.push({
    name: AppRoute.DEVELOPER_SETTINGS,
    component: DeveloperSettingsScreen,
    title: 'Developer Settings',
    header: header({
      back: true,
      filter: false,
      burger: true,
      search: false,
    }),
    drawerSortOrder: 999,
    ...commonDrawerRouteProps,
  });
}

const liquorStoreAppRoutes = (
  ecommerceDisabled: boolean,
  isLoggedIn: boolean,
  storeLoyaltyEnabled: boolean,
) =>
  [
    ...drawerRoutes,
    ...tabRoutes(ecommerceDisabled, isLoggedIn, storeLoyaltyEnabled),
    ...noTabOrDrawerRoutes,
  ].map(routeWithNoTargetStoreType => {
    const route: RouteSpec = {
      ...routeWithNoTargetStoreType,
      targetStoreType: TargetStoreType.LiquorStore,
    };
    return route;
  });

export default liquorStoreAppRoutes;
